import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import IconBox from '../../IconBox';

import './PageHeaderBar.scss';

const HEADER_ICON_SIZE = 28;

const PageHeaderBar = ({
	className = '',
	header = '',
	subheader = '',
	icon = null,
	iconLabel = null,
	leftElement = null,
}) => {
	return (
		<div className={classNames('PageHeaderBar', className)}>
			<div className='PageHeaderBar__left-box'>{leftElement}</div>
			<div className='PageHeaderBar__title-box'>
				{icon && <IconBox icon={icon} iconLabel={iconLabel} size={HEADER_ICON_SIZE} />}
				{(header || subheader) && (
					<div className='PageHeaderBar__title-text'>
						{header && <h1 className='PageHeaderBar__title-header'>{header}</h1>}
						{subheader && <h2 className='PageHeaderBar__title-subheader'>{subheader}</h2>}
					</div>
				)}
			</div>
			<div className='PageHeaderBar__right-box'></div>
		</div>
	);
};

PageHeaderBar.propTypes = {
	className: PropTypes.string,
	header: PropTypes.node,
	subheader: PropTypes.node,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PageHeaderBar;
